import { KycApprovalStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { AcceptanceStatus, DataKYCFileTct } from '@dealstack/shared/lib/generated';

export const getKycStatus = (kycFile?: DataKYCFileTct): KycApprovalStatus => {
	if (!kycFile) {
		// No file uploaded yet — distinct from AcceptanceStatus.PENDING - returning
		// null lets `toDocumentStatus` map it to 'REQUESTED' so the step pill matches
		// the KYC table
		return null;
	}
	const status = kycFile.status;
	if (status === AcceptanceStatus.APPROVED) {
		return AcceptanceStatus.APPROVED;
	}
	if (status === AcceptanceStatus.REJECTED || status === AcceptanceStatus.REREQUESTED) {
		return AcceptanceStatus.REJECTED;
	}
	return AcceptanceStatus.PENDING;
};
